import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService, BASE_API_URL, LocalStatusFacade, SESSION_EXPIRED_HANDLER } from '@cnt-workspace/data-access';
import { throwError } from 'rxjs';
import { catchError, first } from 'rxjs/operators';
import { SESSION_EXPIRED_MESSAGE } from './admin-jwt.interceptor';

// Copy of cnt-landing's unauthenticated-error.interceptor.ts. When our own API
// answers 401, the admin's expired handler asks them to sign in again over the
// page they're on (keeping its URL and unsaved edits); without one, it signs out.
export const adminUnauthenticatedErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const statusFacade = inject(LocalStatusFacade);
  const expired = inject(SESSION_EXPIRED_HANDLER, { optional: true });

  return next(request).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse && err.status === 401 && err.url?.includes(BASE_API_URL)) {
        if (expired) {
          expired();
          return throwError(() => new Error(SESSION_EXPIRED_MESSAGE));
        }
        statusFacade.loggedIn$.pipe(first()).subscribe((loggedIn) => {
          if (loggedIn) {
            void auth.signOut('You have been logged out by the server');
          }
        });
        return throwError(() => new Error('You have been logged out by the server'));
      }
      return throwError(() => err);
    }),
  );
};
